export const MUTED_LABEL_COLOR = '#68717d';
export const HEADING_TEXT_COLOR = '#2B2D42';
export const HAIRLINE_BORDER_COLOR = '#edf1f5';
export const LINK_COLOR = '#5C95FF';
export const FIELD_LABEL_COLOR = '#69727d';
export const FIELD_VALUE_COLOR = '#3c4552';
export const BREADCRUMB_TEXT_COLOR = '#59606c';
export const BREADCRUMB_SEPARATOR_COLOR = '#9aa2ad';
export const CARD_BORDER_COLOR = '#e0e5ec';
export const STAT_BORDER_COLOR = '#e3e8ef';
export const PROGRESS_TRACK_COLOR = '#e9eef4';
export const PAY_COLOR = '#7cb342';
export const BTN_BORDER_COLOR = '#d7dee7';
export const PAYMENT_ORIGIN_COLOR = '#7a838d';
export const PAYMENT_DATE_COLOR = '#7b838e';
export const ASSOCIATED_META_COLOR = '#6f7883';
